module.exports = __webpack_public_path__ + "static/media/room-1.9a142714.jpeg";